import React from 'react';
import { AspectRatioProvider } from '../../hooks/useAspectRatio/useAspectRatio';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';

export type SlotCount = 1 | 2 | 3 | 4;

export type GridSlotProps = {
  isPrimary?: boolean;
  slots?: SlotCount;
  children: React.ReactNode;
};

const aspectRatios: { [key in SlotCount]: number | null } = {
  1: null,
  2: 409 / 154,
  3: 409 / 244,
  4: 700 / 330,
};

export const GridSlot = ({ isPrimary = false, slots, children }: GridSlotProps) => {
  const isDesktop = useBreakpoint('md', 'up');
  const ratio = isDesktop && slots ? aspectRatios[slots] : null;

  return (
    <AspectRatioProvider ratio={ratio}>
      <div style={{ gridColumn: isPrimary ? '1 / 2' : undefined, gridRow: isPrimary ? '1 / 5' : `span ${slots}` }}>
        {children}
      </div>
    </AspectRatioProvider>
  );
};
